import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {PageOfContentMinimized} from 'src/app/model/cms-vod-core/content-controller/page-of-content-minimized.model';
import {DealingQueryParams} from 'src/app/model/cms-vod-core/dealing-models/dealing-query-params.model';
import {PageOfLicense} from 'src/app/model/cms-vod-core/dealing-models/page-of-license.model';
import {ExcelContent} from 'src/app/model/content-excel-export.model';
import {Content} from 'src/app/model/content.model';
import {License} from 'src/app/model/license.model';
import {environment} from 'src/environments/environment';
import {PageOfContent} from '../../../model/page-of-content.model';
import {QueryParams} from '../../../model/query-models/query-models';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  readonly licenseApiUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.LICENSE;

  constructor(private http: HttpClient) {}

  getAllLicense(licenseQueryParams?: DealingQueryParams): Observable<PageOfLicense> {
    let queryParams: HttpParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (licenseQueryParams) {
      if (licenseQueryParams.page) {
        queryParams = queryParams.set('page', <any>licenseQueryParams.page);
      }

      if (licenseQueryParams.name) {
        queryParams = queryParams.set('name', <any>licenseQueryParams.name);
      }
      if (licenseQueryParams.status) {
        queryParams = queryParams.set('status', <any>licenseQueryParams.status);
      }
      if (licenseQueryParams.boxOfficeType) {
        queryParams = queryParams.set('boxOfficeType', <any>licenseQueryParams.boxOfficeType);
      }
      if (licenseQueryParams.currency) {
        queryParams = queryParams.set('currency', <any>licenseQueryParams.currency);
      }
      if (licenseQueryParams.serviceType) {
        queryParams = queryParams.set('serviceType', <any>licenseQueryParams.serviceType);
      }
      if (licenseQueryParams.runType) {
        queryParams = queryParams.set('runType', <any>licenseQueryParams.runType);
      }
      if (licenseQueryParams.itemCount) {
        queryParams = queryParams.set('itemCount', <any>licenseQueryParams.itemCount);
      }
      if (licenseQueryParams.sortParam) {
        queryParams = queryParams.set('sortParam', <any>licenseQueryParams.sortParam);
      }
    }
    return this.http.get<PageOfLicense>(this.licenseApiUrl, {params: queryParams});
  }
  getAllLicensesWithoutPagination(): Observable<License[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParams = queryParams.set('pageable', <any>false);
    return this.http.get<License[]>(this.licenseApiUrl, {params: queryParams});
  }

  getLicenseById(licenseId: number): Observable<License> {
    return this.http.get<License>(this.licenseApiUrl + `/${licenseId}`);
  }
  getLicenseByIdPromise(licenseId: number) {
    return this.http.get<License>(this.licenseApiUrl + `/${licenseId}`).toPromise();
  }

  getContentsByLicenseId(qp: QueryParams): Observable<PageOfContentMinimized> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (qp.page) {
      qp.page = qp.page - 1;
      queryParams = queryParams.set('page', <any>qp.page);
    }
    if (qp.itemCount) {
      queryParams = queryParams.set('itemCount', <any>qp.itemCount);
    }
    if (qp.licenseHasContentName) {
      queryParams = queryParams.set('contentName', <any>qp.licenseHasContentName);
    }

    return this.http.get<PageOfContentMinimized>(this.licenseApiUrl + `/${qp.id}/contents`, {params: queryParams});
  }

  createLicense(license: License): Observable<License> {
    return this.http.post<License>(this.licenseApiUrl, license);
  }
  addContentToLicense(contentIds: number[], licenseId: number): Observable<any> {
    return this.http.post<any>(this.licenseApiUrl + `/${licenseId}/contents`, contentIds);
  }
  updateLicense(license: License): Observable<License> {
    return this.http.put<License>(this.licenseApiUrl, license);
  }
  getApplicableContentForLicense(licenseId: number): Observable<any> {
    return this.http.get(this.licenseApiUrl + '/getcontentsbylicensecheck/' + licenseId);
  }

  getContentHasNoActiveLicense(): Observable<ExcelContent[]> {
    return this.http.get<ExcelContent[]>(this.licenseApiUrl + '/withoutlicense/report', {responseType: 'text' as 'json'});
  }

  getContentReportByActiveLicenseExcel(): Observable<ExcelContent[]> {
    return this.http.get<ExcelContent[]>(this.licenseApiUrl + '/activelicense/report', {responseType: 'text' as 'json'});
  }

  getContentHasFutureLicenseExcel(): Observable<ExcelContent[]> {
    return this.http.get<ExcelContent[]>(this.licenseApiUrl + '/upcominglicense/report', {responseType: 'text' as 'json'});
  }

  getContentHasNoLicenseExcel(): Observable<ExcelContent[]> {
    return this.http.get<ExcelContent[]>(this.licenseApiUrl + '/withoutlicense/report', {responseType: 'text' as 'json'});
  }

  getContentTbaLicenseExcel(): Observable<ExcelContent[]> {
    return this.http.get<ExcelContent[]>(this.licenseApiUrl + '/tba/report', {responseType: 'text' as 'json'});
  }

  getContentHasCommercialRights(): Observable<ExcelContent[]> {
    return this.http.get<ExcelContent[]>(this.licenseApiUrl + '/commercialrights/report', {responseType: 'text' as 'json'});
  }
  deleteLicense(licenseId: number): Observable<License> {
    return this.http.delete<License>(this.licenseApiUrl + `/${licenseId}`);
  }

  getAvailableContentsByLicenseId(licenseParam: QueryParams, licenseId: number): Observable<PageOfContentMinimized> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (licenseParam.page > 0) {
      queryParams = queryParams.set('page', <any>licenseParam.page);
    }
    //if (licenseParam.itemCount) {
    if (licenseParam.itemCount) {
      queryParams = queryParams.set('itemCount', <any>licenseParam.itemCount);
    }

    //}
    if (licenseParam.contentName) {
      queryParams = queryParams.set('contentName', <any>licenseParam.contentName);
    }

    return this.http.get<PageOfContentMinimized>(this.licenseApiUrl + `/${licenseId}/availablecontents`, {params: queryParams});
  }

  addContentsToLicense(licenseId?: number, contentIds?: number[]): Observable<any> {
    return this.http.post<any>(this.licenseApiUrl + `/${licenseId}/contents/add`, contentIds, {responseType: 'text' as 'json'});
  }
  removeContentsFromLicense(licenseId?: number, contentIds?: number[]): Observable<any> {
    return this.http.post<any>(this.licenseApiUrl + `/${licenseId}/contents/remove`, contentIds, {responseType: 'text' as 'json'});
  }

  deleteByPlatform(name: string): Observable<any> {
    return this.http.put<any>(this.licenseApiUrl + `/by-platform/${name}/remove`, {responseType: 'text' as 'json'});
  }
}
